import { ActionTree } from 'vuex';
import { AdminState } from './types';
import { RootState } from '@/vuex/types';
import OdataResource from '@/modules/api/OdataResource';
import RestResource from '@/modules/api/RestResource';
import { hourToNumber, numberToHour } from '@/utils/time';
import { EventRegistration, EventTicket, SendNotificationsRequest } from '../models/EventRegistration';

export const actions: ActionTree<AdminState, RootState> = {
    setLoading({ commit }, loading): void {
        commit('storeLoading', loading);
    },
    async fetchEventRegistrations({ commit, state, rootState }): Promise<void> {
        const eventId = rootState.form?.eventId;
        const path = `/registrations/EventRegistrations?$filter=%20EventId%20eq%20${eventId}`;
        const EventRegistrationsUrl = rootState.configuration?.environment.apiUrl + `${path}`;
        const EventRegistrationsResource: OdataResource<EventRegistration> = new OdataResource<EventRegistration>(
            EventRegistrationsUrl,
            function() {
                commit('storeLoading', true);
            },
            function() {
                commit('storeLoading', false);
            },
            function(error: any) {
                console.log(error);
            },
        );
        EventRegistrationsResource.$on('resourcesLoaded', function(resources: any) {
            const eventRegistrations: EventRegistration[] = resources;
            if (eventRegistrations !== undefined && eventRegistrations !== null && eventRegistrations.length) {
                commit('storeEventRegistrations', eventRegistrations);
            }
        });

        await EventRegistrationsResource.getResources('');
    },
    async addEventRegistration({ commit, state, rootState }, eventRegistration: EventRegistration): Promise<void> {
        const eventId = rootState.form?.eventId;
        eventRegistration.eventId = eventId as number;
        eventRegistration.guid = '00000000-0000-0000-0000-000000000000';
        const path = `/registrations/EventRegistrations`;
        const EventRegistrationsUrl = rootState.configuration?.environment.apiUrl + `${path}`;
        const EventRegistrationsResource: OdataResource<EventRegistration> = new OdataResource<EventRegistration>(
            EventRegistrationsUrl,
            function() {
                commit('storeLoading', true);
            },
            function() {
                commit('storeLoading', false);
            },
            function(error: any) {
                console.log(error);
            },
        );

        await EventRegistrationsResource.createNewResource(eventRegistration);
    },
    async patchEventRegistration({ commit, state, rootState }, eventRegistration: any): Promise<void> {
        const path = `/registrations/EventRegistrations`;
        const EventRegistrationsUrl = rootState.configuration?.environment.apiUrl + `${path}`;
        const EventRegistrationsResource: OdataResource<EventRegistration> = new OdataResource<EventRegistration>(
            EventRegistrationsUrl,
            function() {
                commit('storeLoading', true);
            },
            function() {
                commit('storeLoading', false);
            },
            function(error: any) {
                console.log(error);
            },
        );

        await EventRegistrationsResource.patchResource(eventRegistration.id, eventRegistration);
    },
    async sendEventRegistrationConfirmation({ commit, state, rootState }, eventRegistration: any): Promise<void> {
        const path = `/notifications/SendNotificationsRequests`;
        const SendNotificationsRequestsUrl = rootState.configuration?.environment.apiUrl + `${path}`;
        const SendNotificationsRequestsResource: RestResource<SendNotificationsRequest> = new RestResource<
            SendNotificationsRequest
        >(
            SendNotificationsRequestsUrl,
            function() {
                commit('storeLoading', true);
            },
            function() {
                commit('storeLoading', false);
            },
            function(error: any) {
                console.log(error);
            },
        );

        const sendNotificationsRequest: SendNotificationsRequest = {
            id: 0,
            eventId: eventRegistration.eventId,
            recipientEmail: eventRegistration.email,
            includeAlreadySent: true,
            status: eventRegistration.status,
        };
        await SendNotificationsRequestsResource.createNewResource(sendNotificationsRequest);
    },
    async fetchEventTickets({ commit, state, rootState }, eventRegistrationId: number): Promise<void> {
        const path = `/registrations/EventTickets?$filter=%20EventRegistrationId%20eq%20${eventRegistrationId}`;
        const EventTicketsUrl = rootState.configuration?.environment.apiUrl + `${path}`;
        const EventTicketsResource: OdataResource<EventTicket> = new OdataResource<EventTicket>(
            EventTicketsUrl,
            function() {
                commit('storeLoading', true);
            },
            function() {
                commit('storeLoading', false);
            },
            function(error: any) {
                console.log(error);
            },
        );
        EventTicketsResource.$on('resourcesLoaded', function(resources: any) {
            const eventTickets: EventTicket[] = resources;
            if (eventTickets !== undefined && eventTickets !== null && eventTickets.length) {
                commit('storeEventTickets', eventTickets);
            } else {
                commit('storeEventTickets', []);
            }
        });

        await EventTicketsResource.getResources('');
    },
    async addEventTicket({ commit, state, rootState }, eventTicket: EventTicket): Promise<void> {
        const eventId = rootState.form?.eventId;
        eventTicket.eventId = eventId as number;
        eventTicket.guid = '00000000-0000-0000-0000-000000000000';
        const path = `/registrations/EventTickets`;
        const EventTicketsUrl = rootState.configuration?.environment.apiUrl + `${path}`;
        const EventTicketsResource: OdataResource<EventTicket> = new OdataResource<EventTicket>(
            EventTicketsUrl,
            function() {
                commit('storeLoading', true);
            },
            function() {
                commit('storeLoading', false);
            },
            function(error: any) {
                console.log(error);
            },
        );

        await EventTicketsResource.createNewResource(eventTicket);
    },
    async patchEventTicket({ commit, state, rootState }, eventTicket: any): Promise<void> {
        const path = `/registrations/EventTickets`;
        const EventTicketsUrl = rootState.configuration?.environment.apiUrl + `${path}`;
        const EventTicketsResource: OdataResource<EventTicket> = new OdataResource<EventTicket>(
            EventTicketsUrl,
            function() {
                commit('storeLoading', true);
            },
            function() {
                commit('storeLoading', false);
            },
            function(error: any) {
                console.log(error);
            },
        );

        await EventTicketsResource.patchResource(eventTicket.id, eventTicket);
    },
};
